import { render, staticRenderFns } from "./UnitClientsCard.vue?vue&type=template&id=a6f375d8&"
import script from "./UnitClientsCard.vue?vue&type=script&lang=js&"
export * from "./UnitClientsCard.vue?vue&type=script&lang=js&"
import style0 from "./UnitClientsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a6f375d8', component.options)
    } else {
      api.reload('a6f375d8', component.options)
    }
    module.hot.accept("./UnitClientsCard.vue?vue&type=template&id=a6f375d8&", function () {
      api.rerender('a6f375d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitClientsCard.vue"
export default component.exports